import { render, staticRenderFns } from "./onebox-sharelinkuploads.vue?vue&type=template&id=496d49c9&scoped=true&"
import script from "./onebox-sharelinkuploads.vue?vue&type=script&lang=js&"
export * from "./onebox-sharelinkuploads.vue?vue&type=script&lang=js&"
import style0 from "./onebox-sharelinkuploads.vue?vue&type=style&index=0&id=496d49c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496d49c9",
  null
  
)

export default component.exports